import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async removeFiles ({ dispatch }) {
    try {
      const files = await directus.getFiles()
      await directus.deleteItems('directus_files', files.data.map(item => item.id))
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
